import React from 'react';
import { UseQueryResult } from '@tanstack/react-query';
import BackendErrorPage from '../../pages/BackendErrorPage';

type QueryErrorHandlerProps = {
  subscriptionQuery?: UseQueryResult<any, Error>;
  appSettingsQuery?: UseQueryResult<any, Error>;
};

function QueryErrorHandler({ subscriptionQuery, appSettingsQuery }: QueryErrorHandlerProps) {
  const extractStatusCode = (errorMessage?: string): number | undefined => {
    if (!errorMessage) return undefined;
    const statusMatch = errorMessage.match(/(\d{3})/);
    return statusMatch ? parseInt(statusMatch[1], 10) : undefined;
  };

  // Check subscription error
  if (subscriptionQuery && subscriptionQuery.isError) {
    console.error('Subscription query failed:', subscriptionQuery.error);
    const error = subscriptionQuery.error as Error;
    const statusCode = extractStatusCode(error?.message);

    return (
      <BackendErrorPage
        errorType="subscription"
        statusCode={statusCode}
        errorMessage={error?.message || 'Unknown error'}
      />
    );
  }

  // Check app settings error
  if (appSettingsQuery && appSettingsQuery.isError) {
    console.error('AppSettings query failed:', appSettingsQuery.error);
    const error = appSettingsQuery.error as Error;
    const statusCode = extractStatusCode(error?.message);

    return (
      <BackendErrorPage
        errorType="appSettings"
        statusCode={statusCode}
        errorMessage={error?.message || 'Unknown error'}
      />
    );
  }

  return null;
}

export default QueryErrorHandler;
